/**
 * Initializes the alert service for the web by setting up an showNotification (Portal) handler.
 * Once initialized, alerts can be displayed anywhere in the app by calling alertService.alert()
 */

import { showBasicSnackBar } from '@aquariuxfintech/aqx-trader-react-ui/snack-bar';

import { IUIBasicSnackBarProps, snackbarController } from '@aqx-core/common/services/snackbar';

export const useInitWebAlert = () => {
  const webAlert = {
    alert: (params: IUIBasicSnackBarProps) => {
      const { message, messageType, description } = params;
      showBasicSnackBar({
        message,
        messageType,
        fullOverlay: false,
        description
      });
    }
  };

  snackbarController.setSnackbarHandler(webAlert);
};
